export const STATIC_METRIC_TYPES = ['volume', 'share'];

export const DYNAMIC_COLUMN_TYPES = {
  VOLUME: 'Volume',
  SHARE: 'Share',
};

export const STATIC_CURATED_TYPES = ['curated', 'non-curated'];
